module.exports = __webpack_public_path__ + "assets/ParallelogramVOn4Lines.06e2b151829b42978d719d617fd6fc24.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/ParallelogramVOn4Lines.gmt
// module id = 981
// module chunks = 0